var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-speed-dial',{staticClass:"top",attrs:{"direction":"bottom"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-btn',{staticClass:"default-action-btn"},[_vm._v(" Actions ")])]},proxy:true}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }